"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.translationsNamespace = exports.defaultTranslations = void 0;
/* istanbul ignore file @preserve */
/**
 * DO NOT EDIT!
 * This file was autogenerated by npm script `localizations-codegen`.
 * Changes may cause incorrect behavior and will be lost when the file is regenerated.
 *
 * Run `npx localizations-codegen` to regenerate.
 */

const defaultTranslations = exports.defaultTranslations = {
  FindingProduct: 'Finding the best product for you',
  GetNewRecommendation: 'Get new recommendation',
  Recommendation: 'We have a product recommendation for you',
  SeeRecommendedProduct: 'See recommended product'
};
const translationsNamespace = exports.translationsNamespace = 'novage-skincare-advisor';
